import type { Component } from "vue";

export interface IImage {
  file?: File;
  id: string;
  url?: string;
  name: string;
  size: string;
  ext: string;
  title: string;
}

export type SortOrder = "asc" | "desc";

export type ActionType = "delete" | "edit" | "lock" | "unlock" | "change";

export interface IDropdownItem {
  id: ActionType;
  icon: Component;
  title: string;
}

export interface ITab {
  id: string;
  title: string;
}

export interface IAuthForm {
  email: string;
  password: string;
}

export interface IUser {
  id: string;
  first_name: string;
  last_name: string;
  surname: string;
  position: string;
  phone: string;
  email: string;
  blocked_admin: boolean;
  super_admin: boolean;
  roles: IRolesGroup[];
}

export interface IRoles {
  name: string;
  guard_name: string;
}

export interface IRolesGroup {
  name: string;
  permissions: IRoles[];
}

export interface IPermissions {
  permission: Permission;
  group: string;
  groupSlag: string;
  title: string;
  parent: string[];
}

export interface IPermissionsResponse {
  data: IPermissions[];
}

export interface IProfileResponse {
  data: IUser;
}

export interface IAddress {
  value: string;
  unrestricted_value: string;
  data: {
    city_with_type: string;
    fias_id: string;
    geo_lat: string;
    geo_lon: string;
    street_with_type: string;
    country_iso_code: string;
    house_type_full: string;
    house: string;
    region_with_type: string;
    settlement_with_type: string;
  };
}

export interface IAddressResponse {
  data: IAddress[];
}

export interface ICdekCityParams {
  page: number;
  perPage: number;
  title: string;
}

export interface ICdekCity {
  id: string;
  title: string;
}

export interface IICdekCityResponse {
  data: ICdekCity[];
  meta: {
    total: number;
    page: number;
    perPage: number;
    last_page: number;
  };
}

export enum Permission {
  ADMIN_PRODUCT_EDIT = "admin.product.edit",
  ADMIN_PRODUCT_VIEW = "admin.product.show",
  ADMIN_BRAND_EDIT = "admin.brand.edit",
  ADMIN_BRAND_VIEW = "admin.brand.show",
  ADMIN_CATEGORY_EDIT = "admin.category.edit",
  ADMIN_CATEGORY_VIEW = "admin.category.show",
  ADMIN_FEATURE_EDIT = "admin.feature.edit",
  ADMIN_FEATURE_VIEW = "admin.feature.show",
  ADMIN_USER_ADMIN_EDIT = "admin.user.admin.edit",
  ADMIN_USER_ADMIN_VIEW = "admin.user.admin.show",
  ADMIN_WAREHOUSE_EDIT = "admin.warehouse.edit",
  ADMIN_WAREHOUSE_SHOW = "admin.warehouse.show",
  ADMIN_ORDER_SHOW = "admin.order.show",
  ADMIN_ORDER_EDIT = "admin.order.edit",
  ADMIN_POSITION_MOVEMENT_EDIT = "admin.position.movement.edit",
  ADMIN_HISTORY_POSITION_SHOW = "admin.history.position.show",
  ADMIN_COURIER_REQUEST_SHOW = "admin.courier_request.show",
  ADMIN_COURIER_REQUEST_EDIT = "admin.courier_request.edit",
}
